export default __webpack_public_path__ + "static/media/escudo_ranking1.a4aadd68.png";